import { css } from 'twind/css'
import { useState } from 'react'
import { Close, Open } from './Icons'
import { MessagePeek } from './MessagePeek'
import { useTw } from '../../../utils/Styles'
import { useNavigate } from 'react-router-dom'
import { useProfile } from '../../../utils/Profile'
import { isDark, useWidgetOpen } from '../../../utils'
import { useOnMessage } from '../RealtimeWorker/Conversation/Emitter'
import { useNotificationSound } from '../../../utils/NotificationSound'
import { ConversationItemFragment } from '../../../api/Fragments/ConversationItem.generated'

const widget_styles = css`
  width: 60px;
  height: 60px;
  bottom: 20px;
  position: fixed;
  border-radius: 50%;
  transition: all 80ms ease-in-out;
  box-shadow: rgba(0, 0, 0, 0.06) 0px 1px 6px 0px,
    rgba(0, 0, 0, 0.16) 0px 2px 32px 0px;
`

const widget_styles_closed = css`
  opacity: 0;
  transform: scale(0);
  visibility: hidden;
  pointer-events: none;
`

const widget_styles_open = css`
  opacity: 1;
  cursor: pointer;
  transform: scale(1);
  visibility: visible;
  pointer-events: auto;
`

export function WidgetFab({ left }: { left?: boolean }) {
  const tw = useTw()
  const profile = useProfile()
  const navigate = useNavigate()
  const notify = useNotificationSound()
  const { open, responsive, isMobile, setOpen } = useWidgetOpen()
  const [message, setMessage] = useState<ConversationItemFragment | null>(null)
  useOnMessage((message) => {
    if (!open) {
      notify()
      setMessage(message)
    }
  })

  return (
    <>
      {message && (
        <MessagePeek
          left={left}
          message={message}
          onClose={() => {
            setMessage(null)
          }}
          onOpen={() => {
            setMessage(null)
            navigate(`/conversation/${message.conversationId}`)
            setOpen(true)
          }}
        />
      )}
      <div
        style={{ background: profile.fabColor }}
        className={tw(
          widget_styles,
          left ? `left-[20px]` : `right-[20px]`,
          profile === null ? widget_styles_closed : widget_styles_open,
          responsive === 'hide' && isMobile && 'hidden'
        )}
      >
        <Close
          show={open}
          onClick={() => setOpen(false)}
          dark={profile?.fabColor ? isDark(profile.fabColor) : undefined}
        />
        <Open
          show={!open}
          color={profile?.fabColor}
          onClick={() => setOpen(true)}
          background={profile?.fabLogoURL}
        />
      </div>
    </>
  )
}
